import { AllActions } from "../actions";
import { Language } from "../types";

const initialState: Language[] = [];

const getLanguagesSuccess = (languages: Language[]) => {
  return languages;
};

const reducer = (state = initialState, action: AllActions) => {
  switch (action.type) {
    case "GET_LANGUAGES_SUCCESS":
      return getLanguagesSuccess(action.languages);

    default:
      return state;
  }
};

export default reducer;
